import { readerVoices } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Voices() {
  return (
    <section id="voices" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-8 lg:gap-14 items-start">
          <SectionHeading
            eyebrow="Resonance"
            title="被读到的情感共鸣"
            description="文字最好的归宿，是被另一个人的记忆接住。这些来自读者的留言，让长日光阴里的故事有了回声。"
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {readerVoices.map((voice) => (
              <figure
                key={voice.name}
                className="flex flex-col bg-background-50 border border-background-200 rounded-lg p-5"
              >
                <i className="ri-quote-text text-2xl text-accent-400"></i>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {voice.quote}
                </blockquote>
                <figcaption className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-heading text-sm">
                    {voice.name.slice(0, 1)}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-medium text-foreground-900">{voice.name}</span>
                    <span className="text-xs text-foreground-500">{voice.meta}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}